"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FDSUtils = _interopRequireDefault(require("./FDS-Utils"));

var _FDSCrypto = _interopRequireDefault(require("./FDS-Crypto"));

var _Hash = _interopRequireDefault(require("./models/Hash.js"));

var _FDSTrace = _interopRequireDefault(require("./FDS-Trace"));

var _axios = require("axios");

var _beeJs = require("@ethersphere/bee-js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//create stub file class only for node.js applications
if (typeof File === 'undefined') {
  var File = class {
    constructor(content, name, options) {
      this.content = content;
      this.name = name;
      this.type = options.type;
    }

  };
}

var POSTAGE_STAMP = '0000000000000000000000000000000000000000000000000000000000000000';

class Swarm {
  constructor(config, account) {
    this.config = config;
    this.account = account;
    this.gateway = config.beeGateway;
    this.rawGateway = config.beeGateway + '/bytes';
    this.bee = new _beeJs.Bee(this.gateway);
  } //later we'll try to do this offline


  getSwarmDigest(string) {
    var _this = this;

    return _asyncToGenerator(function* () {
      switch (string) {
        case '/shared/mail':
          return '0x723beeeb4a880dc9432fdf3b1b53df942c4ec162ffda83037f2ad2ef94b22c23';

        case '/shared':
          return '0x23e642b7242469a5e3184a6566020c815689149967703a98c0affc14b9ca9b28';

        case '/':
          return '0xc7f5bbf5fe95923f0691c94f666ac3dfed12456cd33bd018e7620c3d93edd5a6';

        default:
          var digest;

          try {
            digest = yield _this.bee.uploadData(POSTAGE_STAMP, string);
          } catch (e) {
            throw new Error(e);
          }

          return '0x' + digest.reference;
      }
    })();
  }

  getSwarmDigestValue(swarmhash) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      swarmhash = swarmhash.replace(/0x/, '');

      switch (swarmhash) {
        case '723beeeb4a880dc9432fdf3b1b53df942c4ec162ffda83037f2ad2ef94b22c23':
          return '/shared/mail';

        case '23e642b7242469a5e3184a6566020c815689149967703a98c0affc14b9ca9b28':
          return '/shared';

        case 'c7f5bbf5fe95923f0691c94f666ac3dfed12456cd33bd018e7620c3d93edd5a6':
          return '/';

        default:
          var value;

          try {
            value = yield _this2.bee.downloadData(swarmhash).then(data => data.text());
          } catch (e) {
            throw new Error(e);
          }

          return value;
      }
    })();
  }
  /**
   * Store unencrypted file to swarm
   * @param {any} file to store
   * @param {any} encryptedProgressCallback callback
   * @param {any} uploadedProgressCallback callback
   * @param {any} progressMessageCallback callback
   * @returns {Hash} with address, file, time and iv
   */


  storeFilesUnencrypted(files) {
    var uploadedProgressCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : console.log;
    var progressMessageCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console.log;
    var pin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var file = files[0];
    var metadata = {
      name: file.name,
      type: file.type,
      size: file.size
    };
    progressMessageCallback('Uploading file');
    return this.bee.uploadFiles(POSTAGE_STAMP, [file], {
      indexDocument: metadata.name
    }).then(hash => {
      return "".concat(this.gateway, "/bzz/").concat(hash === null || hash === void 0 ? void 0 : hash.reference);
    });
  }
  /**
   * Store encrypted file to swarm
   * @param {any} file to store
   * @param {any} secret to use
   * @param {any} encryptedProgressCallback callback
   * @param {any} uploadedProgressCallback callback
   * @param {any} progressMessageCallback callback
   * @returns {Hash} with address, file, time and iv
   */


  storeEncryptedFile(file, secret) {
    var encryptedProgressCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console.log;
    var uploadedProgressCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : console.log;
    var progressMessageCallback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : console.log;
    var pin = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var metadata = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
    progressMessageCallback("encrypting");
    return _FDSUtils.default.fileToBuffer(file).then(buffer => {
      var iv = _FDSCrypto.default.generateRandomIV();

      var encryptedBuffer = _FDSCrypto.default.encryptBuffer(buffer, secret, iv);

      encryptedProgressCallback(true);
      progressMessageCallback("uploading");
      var metadata = {
        name: file.name,
        type: file.type,
        size: file.size
      };
      return this.bee.uploadFile(POSTAGE_STAMP, encryptedBuffer, metadata.name).then(hash => {
        return new _Hash.default({
          address: hash.reference,
          file: file,
          time: Date.now(),
          iv: '0x' + iv.toString('hex'),
          meta: metadata
        }, this.account);
      }).catch(error => {
        throw new Error(error);
      });
    });
  }
  /**
   * Get decrypted file
   * @param {any} hash location
   * @param {any} secret to decrypt
   * @param {any} selectedMailbox mailbox to use
   * @param {any} selectedWallet wallet to use
   * @returns {any} decrypted file
   */


  getDecryptedFile(hash, secret, selectedMailbox, selectedWallet) {
    return this.getDataFromManifest(hash.address, hash.file.name).then(retrievedFile => {
      var decryptedBuffer = _FDSCrypto.default.decryptBuffer(retrievedFile, secret, Buffer.from(hash.iv.substring(2, 34), 'hex'));

      var file;

      if (typeof window === 'object') {
        var blob = new Blob([decryptedBuffer], {
          type: hash.file.type
        });
        blob.name = hash.file.name;
        return blob;
      } else {
        return new File([decryptedBuffer], hash.file.name, {
          type: hash.file.type
        });
      }
    });
  }
  /**
   * Get file from url
   * @param {any} url url
   * @returns {any} result of request
   */


  getFile(url) {
    return this.sendRequest(url, 'GET', 'text');
  }
  /**
   * Get data from url
   * @param {any} url url
   * @returns {any} result of request
   */


  getData(url) {
    return this.sendRequest(url, 'GET', 'arraybuffer');
  }
  /**
   * Get manifest from url
   * @param {any} swarmHash hash
   * @param {any} filename file at hash
   * @returns {any} result of request (manifest)
   */


  getDataFromManifest(swarmHash, filename) {
    var url = this.gateway + '/' + 'bzz/' + swarmHash;
    return this.getData(url).then(data => {
      return data;
    });
  }
  /**
   * Post data
   * @param {any} data data
   * @param {any} progressCallback callback
   * @param {any} protocol protocol to use
   * @returns {any} swarm request data
   */


  postData(data) {
    var progressCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : console.log;
    var protocol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'files';
    var pinHeader = arguments.length > 3 ? arguments[3] : undefined;
    return this.sendRequest(this.gateway + '/' + protocol, 'POST', 'text', data, progressCallback, data.length, pinHeader);
  }

  pin(hash) {
    throw new Error('not implemented');
    return this.sendRequest(this.gateway + '/bzz-pin/', 'POST', 'text', '', progressCallback, 0, true);
  }
  /**
   * Request data
   * @param {any} url to use
   * @param {any} requestType type of request
   * @param {any} data data to send
   * @param {any} progressCallback callback
   * @returns {any} result of request
   */


  sendRequest(url, requestType, responseType, data, progressCallback, dataLength) {
    var pinHeader = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var headers = {
      Accept: 'application/octet-stream'
    };

    if (pinHeader) {// headers['x-swarm-pin'] = true;
    }

    _FDSTrace.default.time('sendRequest//Swarm');

    return (0, _axios.request)({
      responseType: responseType,
      url: "".concat(url),
      method: requestType,
      headers: headers,
      data: data,
      timeout: this.config.swarmTimeout,
      transformResponse: [function (data) {
        if (responseType === 'arraybuffer') {
          return Buffer.from(data);
        } else {
          return data;
        }
      }],
      onUploadProgress: event => {
        if (progressCallback) {
          progressCallback(Math.floor(event.loaded / dataLength * 100, 2));
        }
      }
    }).then(response => {
      _FDSTrace.default.timeEnd('sendRequest//Swarm');

      _FDSTrace.default.log(url, requestType);

      return response.data;
    });
  }

}

var _default = Swarm;
exports.default = _default;
module.exports = exports.default;